import { Controller } from "stimulus"

export default class extends Controller {
  static targets = []

  connect() {}

  handleNavBtn(e) {
    e.preventDefault();

    this.href = e.target.href

    if (e.target.id === "next-btn") {
      this.element.classList.add("show-next-confirmation");
    }
    else {
      this.element.classList.add("show-prev-confirmation");
    }
  }

  handleConfirm() {
    window.location = this.href;
  }

  handleCancel() {
    this.element.classList.remove("show-prev-confirmation", "show-next-confirmation");
  }
}
